/* eslint-disable no-script-url,jsx-a11y/anchor-is-valid */
import React from "react";
import { DDD_DD_MMM_YYYY_HH_MM_SS_A, TIME_ZONE } from "../../../../utils/const";
import Moment from "react-moment";
import "moment-timezone";

export const LastTransactionDateFormatter = (cellContent, row, rowIndex) => {
  const { last_transaction_date } = row;
  return (
    <>
      <div className="d-flex align-items-center">
        {last_transaction_date ? (
          <Moment
            date={last_transaction_date}
            format={DDD_DD_MMM_YYYY_HH_MM_SS_A}
            tz={TIME_ZONE}
          />
        ) : (
          "-"
        )}
      </div>
      <> </>
    </>
  );
};
